import React from 'react'
import { useNavigate } from 'react-router-dom';


function CustomHeader() {

    const navigate = useNavigate()

    const logout = () => {
        localStorage.removeItem('userObj')
        setTimeout(() => {
            navigate('/')
        }, 500)
    }

    return (
        <div className='flex flex-row justify-between p-4 items-center bg-gray-100'>
            <div>
                <img
                    alt=""
                    className="h-14 w-14"
                    src="logo.webp" />
            </div>
            <div>
                <button onClick={logout}>Logout</button>
            </div>
        </div>
    )
}

export default CustomHeader
